import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';

import { fetcherWithToken } from '@/shared/api/fetcher';
import { useIsAuth } from '@/shared/providers/user-provider/use-user';

async function claimRewards(url, { arg }: { arg: string }) {
  const params = new URLSearchParams({ level: arg });
  return fetcherWithToken(`${url}?${params}`, {
    method: 'GET',
  });
}

export const useLoyaltyList = () => {
  const isAuth = useIsAuth();
  const { data, error, mutate } = useSWR(
    isAuth ? '/loyalty/list' : null,
    fetcherWithToken
  );
  const { trigger: claimRewardsTrigger } = useSWRMutation(
    '/loyalty/claimRewards',
    claimRewards
  );
  return {
    loyaltyList: data,
    mutateLoyaltyList: mutate,
    claimRewardsTrigger,
    isLoading: isAuth && !error && !data,
    isError: error,
  };
};
